module.exports = __webpack_public_path__ + "static/media/HelveticaNeueBd.b8edca3e.ttf";